import React, { useEffect, useRef } from 'react';

const Turnstile = ({ onVerify, onError, onExpire }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const callbacksRef = useRef({ onVerify, onError, onExpire });

  // Update callbacks ref when they change
  useEffect(() => {
    callbacksRef.current = { onVerify, onError, onExpire };
  }, [onVerify, onError, onExpire]);

  useEffect(() => {
    // Load Turnstile script if not already loaded
    const loadTurnstile = () => {
      if (window.turnstile) {
        renderTurnstile();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        renderTurnstile();
      };
      document.head.appendChild(script);
    };

    const renderTurnstile = () => {
      if (!containerRef.current || !window.turnstile) return;

      // Remove existing widget if present
      if (widgetIdRef.current !== null) {
        window.turnstile.remove(widgetIdRef.current);
      }

      // Render new widget
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
        callback: (token) => {
          if (callbacksRef.current.onVerify) {
            callbacksRef.current.onVerify(token);
          }
        },
        'error-callback': () => {
          if (callbacksRef.current.onError) {
            callbacksRef.current.onError();
          }
        },
        'expired-callback': () => {
          if (callbacksRef.current.onExpire) {
            callbacksRef.current.onExpire();
          }
        },
        theme: 'light',
      });
    };

    loadTurnstile();

    // Cleanup
    return () => {
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
  }, []); // Empty dependency array - only run once on mount

  return <div ref={containerRef} className="flex justify-center my-4"></div>;
};

export default Turnstile;